<wuc-button type="clean" e2e="modal_close" modal-close-btn>
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>

<h2 modal-title>Schadevrije jaren en uw autoverzekering</h2>
<div modal-content>
    <p>
        Bij het afsluiten van uw autoverzekering vragen wij naar de door u opgebouwde schadevrije jaren. Op basis van uw
        schadevrije jaren krijgt u bij de meeste verzekeraars korting op de premie van uw autoverzekering.
    </p>

    <wuc-accordion>
        <wuc-accordion-item>
            <span slot="title">Wat zijn schadevrije jaren?</span>
            <p>
                Schadevrije jaren zijn de jaren waarin u wel een autoverzekering had, maar geen schade heeft
                geclaimd. Heeft u meerdere voertuigen op uw naam? Dan bouwt u per voertuig apart schadevrije jaren
                op. Hoe meer schadevrije jaren u heeft, hoe meer korting u kunt krijgen op uw autoverzekering.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Registratie in Roy-Data</span>
            <p>
                Alle autoverzekeraars van Nederland registreren het aantal schadevrije jaren in een centrale
                database. Die heet Roy-data. Hier worden schadevrije jaren van auto’s en motoren bijgehouden. Na het
                beëindigen van een verzekering, worden de jaren in Roy-data geregistreerd, zodat u ze mee kunt nemen
                naar uw nieuwe verzekeraar. Heeft u in een leaseauto, een auto van de zaak of in het buitenland
                gereden? Dan staan ze niet in Roy-data.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Zo worden uw schadevrije jaren berekend</span>
            <p>
                Vanaf 1 januari 2016 moeten alle verzekeraars op dezelfde manier omgaan met schadevrije jaren.
                Schadevrije jaren bouwt u op tijdens de periode dat uw autoverzekering loopt, maar alleen als de
                autoverzekering op uw eigen naam staat. Elk jaar dat u geen schade claimt, bouwt u één schadevrij
                jaar op. Heeft u wel schade geclaimd? Dan bent u per claim 5 jaren achteruit gegaan (en als u 16 of
                meer schadevrije jaren of meer had, zakt u in één keer naar 10 schadevrije jaren). Zo kunt u dus ook
                een negatief aantal schadevrije jaren hebben. U kunt uw schadevrije jaren na het beëindigen van de
                verzekering meenemen naar de volgende verzekering.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Schadevrije jaren en autoverzekering afsluiten voor uw eerste auto bij InShared</span>
            <p>
                Bij de
                <wuc-link route="/autoverzekering/berekenen-autoverzekering" cs-salesfunnel-toegang="">aanvraag
                </wuc-link>
                <!--                <a routerLink="/autoverzekering/berekenen-autoverzekering" cs-salesfunnel-toegang=""></a>-->
                vult u zelf de schadevrije jaren in, die u tot nu toe heeft opgebouwd. Wij zoeken uw schadevrije
                jaren daarna op in de centrale database Roy-data. Meestal gaat dat vlekkeloos, als uw vorige
                verzekeraar alles goed in Roy-data heeft gezet.
            </p>
            <p>
                Klopt uw opgave niet of vinden we geen schadevrije jaren in Roy-data? Dan laten we u dat weten per
                mail. Als we binnen 4 weken geen bericht van u krijgen, dan passen wij uw schadevrije jaren en
                premie aan.
            </p>
            <p>
                Klopt de informatie in Roy-data volgens u niet? Neemt u dan contact op met uw vorige verzekeraar.
                Die kan het goede aantal schadevrije jaren in Roy Data zetten.
                <wuc-link [url]="documentsEnum.SampleLetterNoClaimYears" rel="nofollow" target="_blank">Het verzoek
                </wuc-link>
                hebben we alvast voor u geschreven.
            </p>
            <p>
                Is uw aantal schadevrije jaren minder dan -2? Helaas, die auto’s verzekeren we niet. Heeft u al een
                Autoverzekering bij InShared? Of recent gehad? Ga dan naar uw Verzekeringsmap en klik op ‘Direct
                regelen’ en daarna ‘Extra auto verzekeren.’ In sommige situaties is het wel mogelijk.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Schadevrije jaren aantonen</span>
            <p>
                Uw schadevrije jaren in Roy-data zijn voor ons, net als bij andere verzekeraars, één van de
                uitgangspunten om uw premie te bepalen. Als het aantal schadevrije jaren dat u aan ons opgeeft, niet
                klopt met het aantal dat we in Roy Data zien staan, kan dat invloed hebben op uw premie. Vindt u dat
                het aantal niet klopt? Gebruik dan één van de
                <wuc-link url="/autoverzekering/aantonen-schadevrije-jaren">manieren om uw schadevrije jaren aan te
                    tonen
                </wuc-link>
                .
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Als u een tweede auto (of motor) heeft</span>
            <p>
                Veel gezinnen hebben twee auto’s voor de deur staan. Of een auto en een motor. Als u voor het eerst
                een tweede auto of motor koopt, heeft u voor deze auto of motor vaak nul schadevrije jaren. Die
                jaren staan namelijk niet alleen op naam, maar ook op het verzekerde voertuig. De premie van de
                auto- of motorverzekering is dan hoog. Dat vinden wij niet eerlijk. En daarom krijgt u van ons de
                korting die bij de schadevrije jaren van het eerste voertuig hoort en bij het tweede voertuig past!
                Heeft u bijvoorbeeld 16 schadevrije jaren op uw eerste auto, dan krijgt u 80% korting op uw tweede
                auto en 75% korting op uw motor! Dat is toch mooi meegenomen!
            </p>
            <p>
                U vult voor uw tweede voertuig (auto of motor) gewoon het aantal schadevrije jaren van dat kenteken
                in en wij regelen uw extra korting. Dat ziet u ook tijdens het afsluiten. LET OP: Als u bij ons
                weggaat, moeten we jammer genoeg gewoon het daadwerkelijke aantal schadevrije jaren voor dat
                kenteken in Roy Data zetten en krijgt u bij uw nieuwe verzekeraar waarschijnlijk niet dezelfde
                korting meer.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Gebruikmaken schadevrije jaren van uw (ex)-partner of bedrijf</span>
            <p>
                Als de autoverzekering op uw naam staat, maar de schadevrije jaren op naam van uw (ex)-partner of
                bedrijf in Roy Data staan, dan kunt u die helaas niet zomaar overnemen.
            </p>
            <p>
                Wilt u dat toch? Dan kunt u
                <wuc-link [url]="documentsEnum.Waiver" target="_blank">deze afstandsverklaring</wuc-link>
                downloaden en printen. Hij moet zowel door u als de vorige verzekeringsnemer worden ingevuld en
                ondertekend. Uw (ex)-partner of bedrijf is die jaren dan wel kwijt. U stuurt de verklaring naar ons
                op en wij nemen de schadevrije jaren op naam van uw (ex)-partner of bedrijf in gebruik.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Gebruikmaken van schadevrije jaren van de ouders</span>
            <p>
                Veel jongeren vinden een autoverzekering erg duur. Dat komt door hun leeftijd (omdat het risico op
                schade groter is bij jongeren, is ook de premie hoger), maar ook omdat ze nog geen jaren schadevrij
                hebben gereden. Dan kan de verzekering op naam van één van de ouders afgesloten worden. Maar alleen
                als de auto ook op naam van één van de ouders in de RDW staat, het kind op hetzelfde adres woont en
                wordt opgegeven als afwijkende bestuurder. Het afsluiten op naam van de ouders heeft wel 3 nadelen:
            </p>
            <wuc-list icon="dot-small">
                <wuc-list-item>Bij schade heeft het consequenties voor de opgebouwde schadevrije jaren van de ouder
                </wuc-list-item>
                <wuc-list-item>Er worden geen schadevrije jaren opgebouwd op naam van de jongere</wuc-list-item>
                <wuc-list-item>Vaak staat er in de voorwaarden een clausule waarbij het eigen risico hoger is als één
                    van de kinderen reed bij een aanrijding
                </wuc-list-item>
            </wuc-list>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Uw schadevrije jaren opvragen</span>
            <p>
                Wilt u weten hoe het ervoor staat met uw schadevrije jaren? Dan kunt u het beste uw schadevrije
                jaren opvragen bij uw huidige verzekeringsmaatschappij. Zij kunnen u precies vertellen hoeveel
                schadevrije jaren u tot nu toe heeft opgebouwd.
            </p>
            <p>
                Heeft u geen verzekeringen meer? Dan kunt u de schadevrije jaren opvragen die in Roy-data
                geregistreerd staan via Seps.nl. Let op: als de opgevraagde jaren bij een andere maatschappij in
                gebruik zijn, kunt u ze niet gebruiken voor een nieuwe verzekering.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Handige brochure</span>
            <p>
                Voor wie echt álles wil weten over schadevrije jaren: lees
                <wuc-link [url]="documentsEnum.NoClaimYearsQA" target="_blank">de handige brochure</wuc-link>
                van het Verbond van Verzekeraars met de meest gestelde vragen &amp; antwoorden (per 1 januari 2016).
            </p>
        </wuc-accordion-item>
    </wuc-accordion>
</div>
